import type { StorefrontProduct } from '../api/client';
import type { Commerce } from './ShopCommerce';

// Builds the cart a preview's checkout shows: one each of the theme's first two sample products, priced at their own price.
export function sampleCommerce(base: Commerce, samples: readonly StorefrontProduct[]): Commerce {
  const picked = samples.slice(0, 2);
  const lines = picked.map((product) => ({ slug: product.slug, variantId: product.variants[0]?.id ?? product.id, quantity: 1 }));
  const priced = picked.map((product, index) => {
    const price = product.variants[0]?.price ?? '0';
    return { variantId: lines[index].variantId, productId: product.id, quantity: 1, unitPrice: price, totalPrice: price };
  });
  const subtotal = Math.round(priced.reduce((sum, row) => sum + Number(row.totalPrice), 0) * 100) / 100;
  return { ...base, lines, products: picked, quote: picked.length ? { subtotal, lines: priced } : null, loading: false, error: '', order: null };
}
